export default function createZoomControl(map) {
  const zoomControlDiv = document.createElement('div');
  const zoomInControlButton = document.createElement('button');
  const zoomOutControlButton = document.createElement('button');
  const divider = document.createElement('hr');

  zoomControlDiv.style.backgroundColor = '#fff';
  zoomControlDiv.classList.add('d-flex', 'flex-column', 'p-2', 'm-4', 'rounded', 'shadow', 'gap-0-5');
  zoomOutControlButton.style.paddingTop = '14px';
  divider.classList.add('border', 'm-0');

  [zoomInControlButton, zoomOutControlButton].forEach((button, index) => {
    const plusIcon = !index;

    button.style.border = 'none';
    button.style.cursor = 'pointer';
    button.classList.add('d-flex', 'btn', 'btn-icon', 'btn-text-primary');
    button.title = `Click to zoom ${plusIcon ? 'in' : 'out'} on the map`;
    button.type = 'button';
    button.innerHTML = `<i class="fa fa-${plusIcon ? 'plus' : 'minus'}"></i>`;

    button.onclick = function () {
      plusIcon ? map.setZoom(map.getZoom() + 1) : map.setZoom(map.getZoom() - 1);
    };

    zoomControlDiv.appendChild(button);
    if (index === 0) {
      zoomControlDiv.appendChild(divider);
    }
  });
  map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(zoomControlDiv);
}
